import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import './Header.css';
import HelpDialog from './HelpDialog/HelpDialog';
import { ChangePasswordPage } from '../ChangePasswordPage/ChangePasswordPage';
import { history } from '../_helpers';

import logo from '../images/logo.png';
import logomark from '../images/logomark.png';
import logoutIcon from '../images/logout.svg';

class Header extends React.Component {
    state = {
        categories: [],
        teams: [],
        showHelpDialog: false,
        showUserSettingsDialog: false,
        width: window.innerWidth
    };
    constructor() {
        super();
        this.handleShowHelpDialog = this.handleShowHelpDialog.bind(this);
        this.handleCloseHelpDialog = this.handleCloseHelpDialog.bind(this);
        this.handleShowUserSettingsDialog = this.handleShowUserSettingsDialog.bind(this);
        this.handleCloseUserSettingsDialog = this.handleCloseUserSettingsDialog.bind(this);
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }
    
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    handleShowHelpDialog() {
        this.setState({ showHelpDialog: true });
    }

    handleCloseHelpDialog() {
        this.setState({ showHelpDialog: false });
    }

    handleShowUserSettingsDialog() {
        if (this.hasSettingsAccess()) {
            this.setState({ showUserSettingsDialog: true });
        }
    }

    handleCloseUserSettingsDialog() {
        this.setState({ showUserSettingsDialog: false });
    }

    hasSettingsAccess = () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            const parts = user.userName.split('@');
            if (parts[1].toUpperCase() === 'OMC.COM') {
                history.push("/feature-disabled");
                return false;
            }
            return true;
        } catch (e) {
            return false;
        }
    }

    render() {
        const { user } = this.props;
        var isJudge = user && user.roles && user.roles.indexOf('infuzion-judge') > -1;
        var isAdmin = user && user.roles && user.roles.indexOf('infuzion-admin') > -1;
        var showVote = isJudge && isAdmin;
        var showResults = isJudge && isAdmin;
        const { width } = this.state;
        const isMobile = width <= 930;

        const currentYear = new Date().getFullYear();

        return <div className="header">
            <div className="logo">
                {showVote ? (
                    <Link to="/vote">
                        <img src={logomark} className="App-logomark" alt="logomark" />
                        <img src={logo} className="App-logo" alt="logo" />
                    </Link>
                ) : (
                    <img src={logo} className="App-logo" alt="logo" />
                )}
            </div>
            {user &&
                <div className="header-menu">
                    {isAdmin && <Link to="/results" className="admin-link" >Admin</Link>}
                    
                    <Dropdown align="end" className="user-dropdown">
                        <Dropdown.Toggle as={Nav.Link} id="user-dropdown-toggle" className="user-profile-toggle">
                            <i className="fas fa-bars"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#" title="" onClick={() => this.handleShowUserSettingsDialog()}>User Settings</Dropdown.Item >
                            <Dropdown.Item href="https://www.zadv.com/privacy/" target="_blank" rel="noopener noreferrer" title="">
                                Privacy Policy
                            </Dropdown.Item>
                            <Dropdown.Item href="#" title="" onClick={() => this.handleShowHelpDialog() }>Help</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/login" title="">Signout</Dropdown.Item>

                            <Dropdown.Item disabled className="dropdown-copyright-text">
                                Copyright © {currentYear} Zimmerman Advertising
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {!isMobile && (
                    <>
                        <span className="user-name"> {user.userName}</span>
                        <Link to="/login">
                            <img src={logoutIcon} className="logout-image" alt="Logout Icon" />
                        </Link>
                    </>
                    )}
                </div>
            }

            {<HelpDialog
                show={this.state.showHelpDialog}
                handleClose={this.handleCloseHelpDialog}
            />}

            {this.state.showUserSettingsDialog &&
                <ChangePasswordPage
                    show={this.state.showUserSettingsDialog}
                    onClose={this.handleCloseUserSettingsDialog}
                />
            }

        </div>
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    const { user } = authentication;
    return {
        user
    };
}
const connectedHeader = connect(mapStateToProps)(Header);

export default connectedHeader;